<div class="form-dialog">
  <h1>Event Model upload parse warnings and errors</h1>
  <mat-dialog-content>
    <mat-tab-group>
      <mat-tab [label]="'Errors (' + parse_response.parsed_count.error + ')'">
        @if (parse_response) {
          <h2>These rows were completely skipped.</h2>
          <table>
            <tr>
              <th>Row Index</th>
              @for (h of parse_response.columns; track h) {
                <th>{{h}}</th>
              }
            </tr>
            @for (err of parse_response.errors; track err) {
              <tr>
                <td>{{err.row_index}}</td>
                @for (d of err.row_data; track d) {
                  <td>{{d}}</td>
                }
              </tr>
              <tr>
                <td [colSpan]="parse_response.columns.length + 1">      {{err.error_message}}</td>
              </tr>
            }
          </table>
        }
      </mat-tab>
      <mat-tab [label]="'Warnings (' + parse_response.parsed_count.warning + ')'">
        @if (parse_response) {
          <h2>These rows were partially updated.</h2>
          <table>
            <tr>
              <th>Row Index</th>
              @for (h of parse_response.columns; track h) {
                <th>{{h}}</th>
              }
            </tr>
            @for (warn of parse_response.warnings; track warn) {
              <tr>
                <td>{{warn.row_index}}</td>
                @for (d of warn.row_data; track d) {
                  <td>{{d}}</td>
                }
              </tr>
              <tr>
                <td [colSpan]="parse_response.columns.length + 1">
                  <ul>
                    @for (m of warn.warning_messages; track m) {
                      <li>{{m.message}}</li>
                    }
                  </ul>
                </td>
              </tr>
            }
          </table>
        }
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
  <div class="action-buttons">
    <button (click)="closeDialog()" class="btn-close"> Close</button>
  </div>
</div>
